export default __webpack_public_path__ + "assets/35dc99affa874def16b389edab58e583.svg";